import React from 'react'
import { MessageWrapper } from './MessageWrapper'
import { MessageSwitchProps } from '../MessageSwitch'
import { MessageTyping } from '~/service/chatConn/types'

type TypingProps = MessageSwitchProps<MessageTyping>

const Typing: React.FC<TypingProps> = ({ ...props }) => {
  return (
    <MessageWrapper className="is-typing" {...props}>
      <div />
      <div />
      <div />
    </MessageWrapper>
  )
}

export default Typing
